import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VALIDATOR_MESSAGES } from '../../validators/validator-messages';
import { CustomValidators } from 'ng2-validation';
import { Subject } from 'rxjs';

// Modal de mensajes
import swal from 'sweetalert2';

@Component({
  selector: 'app-delete-registro',
  templateUrl: './delete-registro.component.html',
  styleUrls: [
    '../../../scss/form.scss',
    '../../../assets/icon/icofont/css/icofont.scss'
  ]
})
export class DeleteRegistroComponent implements OnInit {
  formDelete: FormGroup;
  registro: FormControl;

  errorMessage: string;
  idconfirmar: number;
  nombreConfirmar: string;
  validatorMessages = VALIDATOR_MESSAGES;
  onSuccess: Subject<Boolean>;
  serviceDelete: any;

  constructor(public bsModalRef: BsModalRef) {
    this.registro = new FormControl();

    this.formDelete = new FormGroup({
      registro: this.registro
    });

    this.onSuccess = new Subject<Boolean>();
  }

  ngOnInit() {
    this.registro.setValidators([Validators.required, CustomValidators.equal(this.nombreConfirmar)]);
  }

  onDelete(): void {
    if (this.formDelete.invalid) { return; }

    this.serviceDelete.delete(this.idconfirmar)
      .subscribe(
        res => {
          if (!res && !res.success) { return; }
          this.onSuccess.next(res.success);
          this.bsModalRef.hide();
          swal( 'Usuario eliminado', 'Registro Borrado  Correctamente.', 'success' );
        },
        error => {
          // this.errorMessage = <any>error
          this.bsModalRef.hide();
          swal('Problemas al borrar el registro', 'Verifique los campos que esten correctos.', 'error');
        });

  }

}
